export enum IOrgSentimentReportEnum {
  Id = 'OrgSentimentReport.id',
  AccountId = 'OrgSentimentReport.accountid',
  UserId = 'OrgSentimentReport.userid',
  Date = 'OrgSentimentReport.date',
  LocalDate = 'OrgSentimentReport.localdate',
  ReportType = 'OrgSentimentReport.reporttype',
  Score = 'OrgSentimentReport.score',
  Notes = 'OrgSentimentReport.notes',
  CreatedAt = 'OrgSentimentReport.createdat',
  UpdatedAt = 'OrgSentimentReport.updatedat',
  CreatedBy = 'OrgSentimentReport.createdby',
  UpdatedBy = 'OrgSentimentReport.updatedby',
  DeletedAt = 'OrgSentimentReport.deletedat',
  DeletedBy = 'OrgSentimentReport.deletedby',
  Count = 'OrgSentimentReport.count',
  NegativeCount = 'OrgSentimentReport.negativecount',
  NeutralCount = 'OrgSentimentReport.neutralcount',
  PositiveCount = 'OrgSentimentReport.positivecount',
  TotalScore = 'OrgSentimentReport.totalscore',
  DayCount = 'OrgSentimentReport.daycount',
  WeekdayIndex = 'OrgSentimentReport.weekdayindex',
  DepartmentId = 'OrgSentimentReport.departmentid',
}
export enum IOrgSentimentReportSegmentsEnum {
  monday = 'OrgSentimentReport.monday',
  tuesday = 'OrgSentimentReport.tuesday',
  wednesday = 'OrgSentimentReport.wednesday',
  thursday = 'OrgSentimentReport.thursday',
  friday = 'OrgSentimentReport.friday',
  saturday = 'OrgSentimentReport.saturday',
  sunday = 'OrgSentimentReport.sunday',
}
